import BottomSheet from './BottomSheet';
import { Avatar } from './ReactionsSheet';
import type { ReachViewer } from '@/types';

/**
 * reco-sheet-per-gesture — the author's legend, in full.
 *
 * One gesture, one sheet: tapping the legend on the card means "what did they
 * say", so this sheet holds the legend and nothing else. The text is the one
 * the card displays (translated or original, per the card's "…" toggle) — it
 * shows in full what the card truncates, no more.
 */
export default function CaptionSheet({
  open,
  author,
  text,
  onClose,
}: {
  open: boolean;
  author: ReachViewer;
  text: string;
  onClose: () => void;
}) {
  return (
    <BottomSheet open={open} title={author.username ?? ''} onClose={onClose} testid="caption-sheet">
      <div className="tw:flex tw:items-start tw:gap-2">
        <Avatar user={author} size="tw:size-8" />
        <p
          data-testid="caption-sheet-text"
          className="tw:min-w-0 tw:flex-1 tw:whitespace-pre-wrap tw:rounded-2xl tw:bg-dark-primary tw:p-3 tw:text-base tw:text-grey-2"
        >
          {text}
        </p>
      </div>
    </BottomSheet>
  );
}
